/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import InquiryToCustomer from "@/src/types/Entities/InquiryToCustomer";
import { fetchResource, queryKeys, updateResource } from "@/src/services/reactQuery/reactQueryService";

const inquiryToCustomerApiUri = "/inquiry_to_customers";

export const useInquiryToCustomer = (id: number, shouldFetchInquiry = true) => {
  const queryClient = useQueryClient();
  const query = useQuery<InquiryToCustomer>({
    queryKey: queryKeys.item(inquiryToCustomerApiUri, id),
    queryFn: () => fetchResource(inquiryToCustomerApiUri, id),
    enabled: shouldFetchInquiry,
  });

  const updateMutation = useMutation<InquiryToCustomer, Error, Partial<InquiryToCustomer>>({
    mutationFn: (data) => updateResource({ uri: inquiryToCustomerApiUri, id, data }),
    onSuccess: (updatedInquiry) => queryClient.setQueryData(queryKeys.item(inquiryToCustomerApiUri, id), updatedInquiry),
  });

  return {
    ...query,
    updateInquiryToCustomer: updateMutation.mutateAsync,
  };
};
